import { Link, useSearchParams } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import { AcademicCommonProps, BreadCrumb } from "../../../../types/dataModel";
import AcadmicWizModal, { DropDownProps, MsgBoxProps } from "./acadmicWizModal";
import { useEffect, useState } from "react";
import CopyRightInfo from "../../../../core/common/copyRightInfo";
import { useAccess } from "../../../../hooks/accessContext";

const DATA_BS_TOOGLE_ID = "pill"
interface Props {
  pageHeading: string
  msgBoxProps?: MsgBoxProps
  heading: string
  headingTag: string
  renderRowStartTag: (props: any)=> JSX.Element
  renderRowEndTag: (prnt: any, child:any)=> JSX.Element
  renderTitleTags: (props: any)=> JSX.Element
  renderTitle?: (props: any)=> JSX.Element
  renderStats?: (props:any)=> JSX.Element
  addButtonTxt: string
  data: AcademicCommonProps []
  breadCrumbs: BreadCrumb[]

  formHeading: string
  formDropDownParent: DropDownProps
  formDropDownChild: DropDownProps
  onSave : (valPrnt:any, valChild:any)=>void
}

const AcademicWiz = (props:Props) => {
  const {hasAcademicMgntEdit} = useAccess()
  const [searchParams] = useSearchParams();
  const [crrProps, setCurrProps] = useState<Props>(props)
  const [selectedCode, setSelectedCode] = useState<string | undefined>('')

  useEffect(() => {
    let code = searchParams.get("code")
    if (code){
      setSelectedCode(code)
    }
  }, [searchParams]);

  useEffect(()=>{
    setCurrProps(props)
  },[props])

  useEffect(()=>{
    if(selectedCode){
      setCurrProps({
        ...crrProps,
        formDropDownParent: {
          ...crrProps.formDropDownParent,
          dropDownDefault : crrProps.formDropDownParent.dropDownItems?.find((item:any)=> item.value === selectedCode)
        }
      })
    } else {
      setCurrProps({
        ...crrProps,
        formDropDownParent: {
          ...crrProps.formDropDownParent,
          dropDownDefault : undefined
        }
      })
    }
    
  },[selectedCode])

  const renderCrums = (crums:any) => {
    return (
      <nav>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <Link to={all_routes.adminDashboard}>
              <i className="ti ti-smart-home" />
            </Link>
          </li>
          {crums?.map((item:any, idx:number) => {
            if (crums?.length - 1 === idx) {
              return (
              <li key={idx} className="breadcrumb-item active" aria-current="page">
                {item.title}
              </li>)
            } else if (!item?.link) {
              return (<>
                <li key={idx}  className="breadcrumb-item">{item.title}</li>
              </>)
            } else {
              return (
                <li key={idx}  className="breadcrumb-item">
                  <Link to={item?.link}>
                    {item.title}
                  </Link>
                </li>
              )
            }
          })}
        </ol>
      </nav>
    )
  }

  const renderTitleAndStats = (academicProps: AcademicCommonProps[]) => {
    return (
      <div className="row gy-3 mb-3">
      <div className="col-sm-4">
        <div className="d-flex align-items-center">
          <h4>{props.heading}</h4>
          <span className="badge badge-dark rounded-pill badge-xs ms-2">
            {props.headingTag}
          </span>
        </div>
      </div>
      <div className="col-sm-8">
        {props.renderStats ? props.renderStats(academicProps) : <></>}
      </div>
    </div>
    )
  }

  const renderAccordingTabHeader = (academicProps: AcademicCommonProps[]) => {

    return (
      <div className="row border-bottom mb-3">
        <div className="col-lg-12">
          <div className="d-contents align-items-center justify-content-lg-between flex-wrap row-gap-3 mb-3">
            <div className="d-flex align-items-center">
                  <button
                    disabled={!hasAcademicMgntEdit() || props?.data?.find((item:AcademicCommonProps)=>item.code === selectedCode)?.status === 'INACTIVE'}
                    className="btn bg-primary-transparent border-dashed border-primary w-100 text-start"
                    data-bs-toggle="modal" data-inert={true}
                    data-bs-target="#add_todo"
                  >
                    <i className="ti ti-plus me-2" />
                    {props.addButtonTxt}
                  </button>
            </div>
          </div>
        </div>
        <div className="col-lg-12">
        {
          academicProps?.length
          ?
              <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">

                <ul
                  className="nav nav-pills border d-inline-flex p-1 rounded bg-light todo-tabs w-100 justify-content-evenly"
                  id="pills-tab"
                  role="tablist"
                >

                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link btn btn-sm btn-icon py-3 d-flex align-items-center justify-content-center w-auto ${ selectedCode ? '' : 'active'}`}
                      data-bs-toggle={DATA_BS_TOOGLE_ID}
                      data-bs-target={`#${DATA_BS_TOOGLE_ID}-home`}
                      type="button"
                      role="tab"
                      aria-selected="true"
                      onClick={()=>{
                        setSelectedCode(undefined)
                      }}
                    >
                      All
                    </button>
                  </li>

                  {
                    academicProps?.map((cc: any, indx) => {
                      return (
                        <li key={indx} className="nav-item" role="presentation">
                          <button
                            className={`nav-link btn btn-sm btn-icon py-3 d-flex align-items-center justify-content-center w-auto ${ selectedCode === cc.code ? 'active' : ''}`}
                            data-bs-toggle={DATA_BS_TOOGLE_ID}
                            data-bs-target={`#${DATA_BS_TOOGLE_ID}-${indx}`}
                            type="button"
                            role="tab"
                            aria-selected="false"
                            onClick={()=>{
                              setSelectedCode(cc?.code)
                            }}
                          >
                            {cc.title}
                          </button>
                        </li>
                      )
                    })
                  }

                </ul>
              </div>

          :
              <></>
        }
        </div>

      </div>
    )
  }

  const renderItemRow = (cc:AcademicCommonProps, cr:AcademicCommonProps, indx:number) => {
    return (
      <div key={indx} className="row align-items-center row-gap-3 shadow-sm pt-2 pb-2">
        <div className="col-lg-6 col-md-7">
          <div className="todo-inbox-check d-flex align-items-center flex-wrap row-gap-3">
            <span className="me-2 d-flex align-items-center">
              <i className="ti ti-grid-dots text-dark" />
            </span>
            {/* <div className="form-check form-check-md me-2">
              <input
                className="form-check-input"
                type="checkbox"
              />
            </div> */}
            {/* <span className="me-2 rating-select d-flex align-items-center">
              <i className="ti ti-star" />
            </span> */}
            <div className="strike-info">
              <h4 className="fs-14">
                {cr.title} 
              </h4>
            </div>
            {props.renderRowStartTag(cr)}
          </div>
        </div>
        <div className="col-lg-6 col-md-5">
            {props.renderRowEndTag(cc, cr)}
        </div>
      </div>
    )
  }

  const renderGroupHeader = (cc: AcademicCommonProps, indx: number) => {
    return (
      <>
        <div className="col-lg-12 col-sm-6">
          <div className="accordion-header" id={`heading-${cc.code}-${indx}`}>
            <div
              className="accordion-button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${cc.code}-${indx}`}
              aria-controls={`collapse-${cc.code}-${indx}`}
            >
              <div className="d-flex align-items-center w-100">
                <div className="me-2">
                  <Link to="#">
                    <span>
                      <i className="fas fa-chevron-down" />
                    </span>
                  </Link>
                </div>
                <div className="d-flex-md-block align-items-center">
                  {
                    props.renderTitle
                    ?
                    props.renderTitle(cc)
                    :
                    <div className="d-flex">
                      <span>
                        <i className="ti ti-square-rounded text-success me-2" />
                      </span>
                      <h5 className="fw-semibold">{cc.title}</h5>
                    </div>
                  }

                  {props.renderTitleTags(cc)}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-5 col-sm-6">
          <div className="d-flex align-items-center justify-content-sm-end">
            <Link
              to="#"
              className="btn btn-light me-2"
              data-bs-toggle="modal" data-inert={true}
              data-bs-target="#add_todo"
            >
              <i className="ti ti-circle-plus me-2" />
              Add New
            </Link>
            <Link to="#"               
              className="btn btn-danger-light me-2"
              data-bs-toggle="modal" data-inert={true}
              data-bs-target="#delete_modal">
                <i className="ti ti-trash me-2" />
                Delete Selected
            </Link>
          </div>
        </div> */}
      </>
    )
  }

  const renderAccordingTabsBody = (academicProps : AcademicCommonProps[]) => {
    return (
      <div className="tab-content" id="pills-tabContent">
        <div className={`tab-pane fade show ${ selectedCode ? '' : 'active'}`} id={`${DATA_BS_TOOGLE_ID}-home`} role="tabpanel"
        >
          <div className="accordion todo-accordion">
            <div className="accordion-item mb-3">
              {
                academicProps?.map((cc, indx) => {
                  return (
                    <div key={indx} className="accordion-item mb-3">
                      <div className="row align-items-center mb-3 row-gap-3">
                        <>{renderGroupHeader(cc, indx)}</>
                      </div>
                      <div
                        id={`collapse-${cc.code}-${indx}`}
                        className="accordion-collapse collapse show"
                        aria-labelledby={`heading-${cc.code}-${indx}`}
                      >
                        <div className="accordion-body">
                          <div className="list-group list-group-flush">
                            <div className="list-group-item list-item-hover shadow-sm rounded mb-2 p-3">
                              {
                                cc?.items?.map((cr: any, indx: number) => {
                                  return (
                                    <>
                                      {renderItemRow(cc, cr, indx)}
                                    </>
                                  )
                                })
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
        {
          academicProps?.map((cc: any, indx) => {
            return (
              <div key={indx} className={`tab-pane fade ${ selectedCode === cc.code ? 'show active' : ''}`} id={`${DATA_BS_TOOGLE_ID}-${indx}`} role="tabpanel">
                <div className="accordion todo-accordion">
                  <div className="accordion-item mb-3">
                    <div className="row align-items-center mb-3 row-gap-3">
                      <>{renderGroupHeader(cc, indx)}</>
                    </div>
                    <div
                      id={`collapse-${cc.code}-${indx}`}
                      className="accordion-collapse collapse show"
                      aria-labelledby={`heading-${cc.code}-${indx}`}
                    >
                      <div className="accordion-body">
                        <div className="list-group list-group-flush">
                          <div className="list-group-item list-item-hover shadow-sm rounded mb-2 p-3">
                            {
                              cc?.items?.map((cr: any, indx: number) => {
                                return (
                                  <>
                                    {renderItemRow(cc, cr, indx)}
                                  </>
                                )
                              })
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">{props.pageHeading}</h2>
                {renderCrums(props.breadCrumbs)}
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                {/* <div className="">
                  <div className="input-icon-start position-relative">
                    <span className="input-icon-addon">
                      <i className="ti ti-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search list ..."
                    />
                  </div>
                </div> */}
                <div className="ms-2 mb-0 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                {renderTitleAndStats(crrProps.data)}
                {renderAccordingTabHeader(crrProps.data)}
                {renderAccordingTabsBody(crrProps.data)}
                {/* {renderLoadButton()} */}
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
            <CopyRightInfo/>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

      <AcadmicWizModal 
        msgBoxProps={crrProps.msgBoxProps}
        heading={crrProps.formHeading} 
        dropDownParent={crrProps.formDropDownParent}
        dropDownChild={crrProps.formDropDownChild}
        onSave={crrProps.onSave}
      />
    </>
  );
};

export default AcademicWiz;